import React from 'react';
import StarRating from '@components/V4/StarRating/StarRating';

interface FeedbackEntryProps {
  title: string;
  score?: string;
  description: string;
  starRating?: number;
}

const FeedbackEntry = (props: FeedbackEntryProps) => {
  const { title, score, description, starRating } = props;
  const hasStarRating = typeof starRating === 'number';

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between items-center">
        <p className="text-customGrey text-xs leading-5">{title}</p>
        {!hasStarRating && !!score && (
          <p className="text-xs font-semibold leading-5">{score}</p>
        )}
      </div>

      {hasStarRating && (
        <div className="flex items-center gap-2">
          <StarRating value={starRating} size="small" isReadOnly />
          {!!score && <p className="text-xs font-semibold leading-5">{score}</p>}
        </div>
      )}

      <p className="text-xs leading-5">{description}</p>
    </div>
  );
};

export default FeedbackEntry;
